// Local Payroll
// export const REST_SERVICE_URL_ROOT = 'http://localhost:5003/api';
// export const PAYROLL_REST_SERVICE_URL_ROOT = 'http://localhost:5002/api';
// Staging Payroll
// export const REST_SERVICE_URL_ROOT = 'http://138.91.40.43:5005/api';
// export const PAYROLL_REST_SERVICE_URL_ROOT = 'http://138.91.40.43:44329/api';
// Production Payroll
export const REST_SERVICE_URL_ROOT = 'https://jobs.alliance.com.ph:5005/api';
export const PAYROLL_REST_SERVICE_URL_ROOT = 'https://jobs.alliance.com.ph:44329/api';

// HR Recruitment ReCaptcha
export const RECAPTCHA_KEY = '6LclK7IqAAAAAI-QxP1aH3DwWoxaoiW8hxrCZpVc'
export const RECAPTCHA_SECRET_KEY = '6LclK7IqAAAAAK-bNgnJTPQkPgaWfpJeN9UPNdUD'

// TINYMCE API KEY
export const TINYMCE_API_KEY = 'rtozkkq9gcp7gazflh3u2y3npncv06miv4lyoszwyxbpmaqi'

// Root Client
// Local
// export const URL_ROOT = 'http://localhost:3003';
// export const HR_URL_ROOT = 'http://localhost:3003';
// Staging
// export const URL_ROOT = 'http://138.91.40.43:5010';
// export const HR_URL_ROOT = 'http://138.91.40.43:5010';
// Production
export const HR_URL_ROOT = 'https://jobs.alliance.com.ph:5010';
export const URL_ROOT = 'https://jobs.alliance.com.ph';

// Persisted key 
export const PERSISTED_STATE_KEY = '@_Persistent_Key';
export const USER_ACCESS = 'userAccess';

// Client Id
export const CLIENT_ID = 'interactive';
// Client Secret
export const CLIENT_SECRET = '49C1A7E1-0C79-4A89-A3D6-A37998FB86B0';
// Root
export const ROOT = '/';

// ids token endpoint
// Local
// export const IDS_ROOT = 'http://localhost:5005';
// Staging
// export const IDS_ROOT = 'http://138.91.40.43:15333';
// Production
export const IDS_ROOT = 'https://jobs.alliance.com.ph:15333';

export const IDS_TOKEN_ENDPOINT = IDS_ROOT + '/connect/token';
export const IDS_USER_ENDPOINT = IDS_ROOT + '/connect/userinfo';
export const IDS_ACCESS_LIST_ENDPOINT = IDS_ROOT + '/claimsAPI/payrollaccesslist';

export const IDS_TOKEN_COOKIE = 'webhrisids_authtoken';
export const HRIS_TOKEN_COOKIE = 'webhris_authtoken';

// OLD WEBHRIS LINK
// Local
// export const WEBHRIS_OLD = 'http://localhost:58539/#'; //FE url
// Staging
// export const WEBHRIS_OLD = 'http://138.91.40.43:5002/#';
// Production
export const WEBHRIS_OLD = 'https://jobs.alliance.com.ph:5002/#';

export const WEBHRIS_OLD_LOGIN_URL = WEBHRIS_OLD + "/portal"; //FE login url
export const WEBHRIS_OLD_DASHBOARD_URL = WEBHRIS_OLD + "/dashboard"; //FE dashboard url

// PAYROLL LINK
// Local
// export const PAYROLL_ROOT = 'http://localhost:3001'; //FE url
// Staging
// export const PAYROLL_ROOT = 'http://138.91.40.43:5000'; // FE staging url
// Production
export const PAYROLL_ROOT = 'https://jobs.alliance.com.ph:5000'; // FE staging url